export class DaySystem {
    static logGuard(economy, stats, report, newQuestsCompleted) {
        const state = economy.state;
        if (!state.dayLog) state.dayLog = [];
        state.guardsToday = (state.guardsToday || 0) + 1;
        
        state.dayLog.push({
            correct: stats.correct,
            total: stats.total,
            avgStability: stats.avgStability,
            xp: stats.xp,
            credits: stats.credits,
            unpaid: stats.unpaid,
            grade: report?.grade || 'C',
            newQuests: newQuestsCompleted || 0
        });
    }

    static getBriefing(economy) {
        const d = economy.state.dayNumber || 1;
        const g = economy.state.guardsToday || 0;
        let turn = "Turno de Mañana";
        if (g === 1) turn = "Turno de Tarde";
        if (g >= 2) turn = "Turno de Noche";

        let drVLine = "Mantén el paso. El hospital no espera a nadie.";
        if (d === 1 && g === 0) drVLine = "Tu primer día real de residencia. No estorbes y aprenderás algo.";
        else if (g === 1) drVLine = "Aún queda mucho día. Revisa a los pacientes pendientes.";
        else if (g >= 2) drVLine = "El turno de noche separa a los médicos de los estudiantes. Concéntrate.";

        return { title: `DÍA ${d} DE RESIDENCIA`, turn, drVLine };
    }

    static endDay(economy) {
        const state = economy.state;
        if (!state.dayLog || state.dayLog.length === 0) return null;

        const summary = {
            day: state.dayNumber || 1,
            guards: state.dayLog.length,
            totalXP: state.dayLog.reduce((s, log) => s + (log.xp || 0), 0),
            totalCredits: state.dayLog.reduce((s, log) => s + (log.credits || 0), 0),
            quests: state.dayLog.reduce((s, log) => s + (log.newQuests || 0), 0)
        };

        const bonusXP = 150 + (summary.guards * 50) + (summary.quests * 100);
        economy.addPlayerXp(bonusXP);
        summary.bonusXP = bonusXP;

        // Limpiar parcialmente burnout
        economy.addBurnout(-20);

        // Reset and advance
        state.dayNumber = (state.dayNumber || 1) + 1;
        state.guardsToday = 0;
        state.dayLog = [];
        
        return summary;
    }
}
